import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#4285F4",
  d: "M19.6 10.227c0-.709-.064-1.39-.182-2.045H10v3.873h5.382a4.6 4.6 0 0 1-2.01 3.009v2.518h3.246c1.891-1.746 2.982-4.31 2.982-7.355"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#34A853",
  d: "M10 20c2.7 0 4.964-.89 6.619-2.418l-3.246-2.518c-.89.6-2.027.963-3.372.963-2.6 0-4.81-1.754-5.6-4.118H1.073v2.582C2.72 17.755 6.091 20 10.001 20"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FBBC04",
  d: "M4.4 11.9c-.2-.6-.318-1.236-.318-1.9S4.2 8.7 4.4 8.1V5.518H1.073A9.9 9.9 0 0 0 0 10c0 1.618.39 3.136 1.073 4.482l2.59-2.018z"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#EA4335",
  d: "M10 3.982c1.473 0 2.782.509 3.828 1.49L16.69 2.61C14.955.991 12.701 0 10.001 0 6.09 0 2.719 2.245 1.072 5.518L4.401 8.1c.79-2.364 3-4.118 5.6-4.118"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }